"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRegion = void 0;
const getRegion = async (supabase, id) => {
    const { data, error } = await supabase
        .from("regions")
        .select(`*,
      primary_airport:areas!primary_airport_id(*),
      modified_by_user:modified_by(id, first_name, last_name), 
      created_by_user:created_by(id, first_name, last_name)`)
        .eq("id", id)
        .single();
    if (!error)
        return data;
    return error;
};
exports.getRegion = getRegion;
